import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_line_chart = _resolveComponent("line-chart")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("span", { class: "h5" }, [
          _createElementVNode("i", {
            class: "fas fa-chart-area fa-fw me-1",
            "aria-hidden": "true"
          }),
          _createTextVNode(" Historial de Puntos ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_line_chart, {
          data: _ctx.chartDataObj,
          options: _ctx.chartOptions,
          ref: "chartRef"
        }, null, 8, ["data", "options"])
      ])
    ])
  ]))
}